export const LEAD_FILTER_ICON_SIZE = 18;
